import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ad2582a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "observations" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = { class: "action-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ib_icons = _resolveComponent("ib-icons")!
  const _component_SlidePreview = _resolveComponent("SlidePreview")!
  const _component_Insight = _resolveComponent("Insight")!
  const _component_k_textarea = _resolveComponent("k-textarea")!
  const _component_WorkflowStateButton = _resolveComponent("WorkflowStateButton")!

  return (_ctx.activeSlide)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["insights-content", _ctx.active ? 'opened' : 'closed']),
          onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.preventScrolling && _ctx.preventScrolling(...args)))
        }, [
          _createElementVNode("div", {
            class: "slide-report-chevron",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleInsights()))
          }, [
            (_ctx.active)
              ? (_openBlock(), _createBlock(_component_ib_icons, {
                  key: 0,
                  size: 18,
                  icon: "nav_arrow_right_active",
                  color: "primary"
                }))
              : (_openBlock(), _createBlock(_component_ib_icons, {
                  key: 1,
                  size: 18,
                  icon: "nav_arrow_left_active",
                  color: "primary"
                }))
          ]),
          _createVNode(_component_SlidePreview, {
            class: "slide report",
            slide: _ctx.activeSlide
          }, null, 8, ["slide"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
              ref: "obsForm"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeSlide.insights, (insight) => {
                return (_openBlock(), _createBlock(_component_Insight, {
                  key: _ctx.activeSlideId + insight.key,
                  insight: insight,
                  title: _ctx.currentSlideReport.isComplete ? _ctx.t('insights.slide_report_complete') : '',
                  isAnalysisPerformed: _ctx.isSlideAnalyzed,
                  prefill: _ctx.getPrefill(insight.key, insight.controller),
                  isActive: insight.key === _ctx.activeInsightKey,
                  isSlideReportComplete: _ctx.currentSlideReport.isComplete,
                  onObservationChange: _ctx.handleChange,
                  onSetActive: _ctx.setActiveInsight
                }, null, 8, ["insight", "title", "isAnalysisPerformed", "prefill", "isActive", "isSlideReportComplete", "onObservationChange", "onSetActive"]))
              }), 128))
            ], 544)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_k_textarea, {
              value: _ctx.currentSlideReport.comments.value,
              onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleChange({ value: $event.value, key: 'comments', title: 'Comments' }))),
              onKeydown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
              placeholder: _ctx.t(`insights.slide_report.comments`),
              disabled: _ctx.currentSlideReport.isComplete
            }, null, 8, ["value", "placeholder", "disabled"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_WorkflowStateButton, {
                onWorkflowStateChange: _ctx.handleWorkflowStateChange,
                id: _ctx.activeSlide.slideId,
                "current-workflow-state": _ctx.activeSlide.workflowState,
                "object-type": "slide",
                disabled: !_ctx.isFormValid
              }, null, 8, ["onWorkflowStateChange", "id", "current-workflow-state", "disabled"])
            ])
          ])
        ], 34)
      ]))
    : _createCommentVNode("", true)
}